import { getBankFieldsWatcher } from './get-bank-fields.saga';

export default [
  getBankFieldsWatcher()
];
